import { useContext } from "react";
import { GenerateDeliveryNoteActionContext } from "./GenerateDeliveryNoteActionContext";
import { BulkActionActionContext } from "@beeldit/core/context/BulkActionContext";

function usePrepareGenerateDeliveryNote() {
  const { setShowModal } = useContext(GenerateDeliveryNoteActionContext);  
  return (ids: any) => {    
    setShowModal(true);
  };
}

export default usePrepareGenerateDeliveryNote;
